<!-- 餐厅-积分结算-结算详情-订单详情 -->

<template>
  <div class="dining-settlement-order-detail">
    <w-dialog ref="dialogRef" class="order-info" title="订单详情" width="55%" btnWidth="140px" top="4vh" :hideFooter="true">
      <w-title :title_name="'订单详情'"></w-title>
      <div class="order-content">
        <el-table class="order-table" :data="infoDates.orderdetail" height="200" style="width: 100%" stripe
          tooltip-effect="light" ref="orderTableRef">
          <el-table-column label="商品">
            <template #default="scope">
              <div class="flex">
                <el-image style="width: 40px; height: 40px;margin-right: 10px;" :src="scope.row.drgf_path_text"
                  :preview-src-list="[scope.row.drgf_path_text]" fit="cover">
                </el-image>
                <div>{{ scope.row.drg_name }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="odrgd_amount" label="数量"></el-table-column>
          <el-table-column property="odrgd_total" label="商品金额"></el-table-column>
          <el-table-column property="odrgd_pack_money" label="打包费"></el-table-column>
        </el-table>

        <div class="order-fee flex-end align-center">
          <div class="order-fee-title">
            <div>打包费：</div>
            <div class="xs-m-t" v-if="infoDates.odrg_receive_way == '1'">配送费：</div>
            <div class="text-blue xs-m-t">总&nbsp&nbsp&nbsp计：</div>
          </div>
          <div class="order-fee-num">
            <div>￥{{ infoDates.odrg_pcharges }}</div>
            <div class="xs-m-t" v-if="infoDates.odrg_receive_way == '1'">￥{{ infoDates.odrg_deliver_fee }}</div>
            <div class="total-num text-blue xs-m-t">￥{{ infoDates.odrg_total }}</div>
          </div>
        </div>
      </div>

      <w-title :title_name="'退款详情'"></w-title>
      <common-table ref="refunTableRef" tableHeight="200" :columns="refundColumns" :tableData="infoDates.refun"
        :ispaging="false">
        <template #status="{ row }">
          <div class="status-text" :class="refundStatusColors(row.orr_status, 'color')">
            {{ refundStatusColors(row.orr_status, 'text') }}
          </div>
        </template>
      </common-table>

      <el-row :gutter="20">
        <el-col :span="12">
          <w-title :title_name="'订单信息'"></w-title>
          <div class="flex">
            <div class="catering-infor-title">下单时间</div>
            <div class="catering-infor-content">{{ infoDates.ctime_text }}</div>
          </div>
          <div class="flex">
            <div class="catering-infor-title">订单来源</div>
            <div class="catering-infor-content">{{ infoDates.odrg_source_text }}</div>
          </div>
          <div class="flex">
            <div class="catering-infor-title">下单用户</div>
            <div class="catering-infor-content">{{ infoDates.m_mobile }}</div>
          </div>
        </el-col>
        <el-col :span="12">
          <w-title :title_name="'配送信息'"></w-title>
          <div class="flex">
            <div class="catering-infor-title">配送地址</div>
            <div class="catering-infor-content">{{ infoDates.odrg_address }}</div>
          </div>
          <div class="flex">
            <div class="catering-infor-title">配送时间</div>
            <div class="catering-infor-content">
              <span>{{ infoDates.odrg_prospect_stime_text }}</span>
              <span v-if="infoDates.odrg_prospect_etime_text">至{{ infoDates.odrg_prospect_etime_text }}</span>
            </div>
          </div>
          <div class="flex" v-if="infoDates.odrg_receive_way == '1'">
            <div class="catering-infor-title">配送费用</div>
            <div class="catering-infor-content">{{ infoDates.odrg_deliver_fee }}</div>
          </div>
        </el-col>
      </el-row>
    </w-dialog>
  </div>
</template>

<script>
import { ref, computed, watch, nextTick, } from "vue";
import { ElMessage, } from "element-plus";
import { DinnerApi, } from "@/plugins/api.js";
import { useStore } from "vuex";

export default {
  emits: ["submit"],
  components: {},
  setup(props, { emit }) {
    const store = useStore();
    const menuTokens = computed(() => store.state.menuToken.menuTokens);
    const authData = ref([]);
    watch(
      () => menuTokens.value,
      (data) => {
        if (data.length) {
          authData.value = data;
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );
    const dialogRef = ref(null);  // 弹框对象
    const currentRow = ref('');  // 当前行数据
    const infoDates = ref([]);  // 详情数据
    const refunTableRef = ref(null);  // 退款表格对象
    const refundColumns = ref([
      {
        prop: "drg_name",
        label: "退款商品",
      },
      {
        prop: "drg_amount",
        label: "退款数量",
      },
      {
        prop: "drg_odrgd_total",
        label: "商品金额",
      },
      {
        prop: "odrr_pack_total",
        label: "打包费",
      },
      {
        prop: "refund_total",
        label: "退款合计",
      },
      {
        prop: "status",
        label: "退款状态",
        type: "customRender",
        minWidth: 120,
      },
    ]);
    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (row) => {
      currentRow.value = row;
      getDetails();
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 打开对话框加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }
    /**
     * 
     * 获取详情数据
     * 
     * **/
    const getDetails = () => {
      DinnerApi.getDinnerOrderInfo({ odrg_id: currentRow.value.odrg_id }).then((res) => {
        if (res.Code === 200) {
          infoDates.value = res.Data;
          dialogRef.value.show();
          nextTick(() => {
            refunTableRef.value.tableLoad();
          });
        } else {
          ElMessage.error(res.Message);
        }
      });
    }
    /**
     * 
     * 退款状态
     * 
     * **/
    const refundStatusColors = (status, type) => {
      let status_text = '';  // 状态（ 0-等待后台审核 1-退款中 2-已退款 3-退款失败 4取消退款订单 5拒绝退款 6人工退款已完成）
      let status_color = '';
      switch (status) {
        case 0:
          status_text = '待审核';
          status_color = 'btn-blue';
          break;
        case 1:
          status_text = '退款中';
          status_color = 'btn-yellow';
          break;
        case 2:
          status_text = '已退款';
          status_color = 'btn-black';
          break;
        case 3:
          status_text = '退款失败';
          status_color = 'btn-red';
          break;
        case 4:
          status_text = '取消退款';
          status_color = 'btn-grey';
          break;
        case 5:
          status_text = '拒绝退款';
          status_color = 'btn-red';
          break;
        case 6:
          status_text = '人工退款已完成';
          status_color = 'btn-orange';
          break;
      }

      if (type == 'text') {
        return status_text;
      } else {
        return status_color;
      }
    }


    return {
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      currentRow,
      getDetails,
      infoDates,
      authData,
      refundColumns,
      refundStatusColors,
      refunTableRef,
    };
  },
};
</script>

<style lang="scss">
.dining-settlement-order-detail {
  
  .order-info {
    .catering-infor-title {
      color: #92979E;
      width: 80px;
      text-align: left;
      margin-bottom: 10px;
      flex-shrink: 0;
    }

    .order-content {
      background-color: #f9f9fb;
      padding: 10px;
    }

    .order-fee {
      color: var(--text-color);
      margin-top: 10px;
    }

    .order-fee-title {
      margin-right: 15px;
    }

    .order-fee-num {
      text-align: end;
    }

    .catering-infor-content {
      color: #262C30;
    }

    .order-table .el-table__cell {
      padding: 9px 0;
    }

    .order-table th.el-table__cell {
      background-color: var(--search-bg-color);
      padding: 9px 0;
      font-size: 15px;
      color: var(--text-color);
    }

    .order-table td.el-table__cell div span {
      font-size: 14px;
    }

    .total-num {
      font-size: 18px;
    }

    .text-blue {
      color: var(--theme-color);
    }
  }
}
</style>